import React from "react";
import { Flex, Grid, Text, Box } from "@fluentui/react-northstar";
import AdvisorTip from "../common/AdvisorTip";
import DonutChart from "../Charts/DonutChart";
import { Col, Row } from "antd";
import { useTranslation } from "react-i18next";

// Overview Tab Component

//  Displays high-level overview of credit consumption and advisor tips

const OverviewTab = ({ data, creditUsage, isLoading }) => {
  const { t } = useTranslation();

  const translation = t("aiConsumption").overview;
  const commonTranslation = t("aiConsumption").common;

  if (isLoading) return <Text content={commonTranslation.loading} />;

  return creditUsage ? (
    <Flex column gap="gap.large">
      {/* <Flex column gap="gap.medium" > */}
      <Text
        size="large"
        weight="bold"
        content={translation.title}
        style={{
          color: "#1F2937",
        }}
      />

      {/* Donut Charts for Teachers and Students */}
      <Row gutter={[10, 10]} style={{ marginBottom: "2rem" }}>
        <Col span={12}>
          <DonutChart
            title={commonTranslation.teachers}
            value={creditUsage.teacher.usedCredits}
            total={creditUsage.teacher.totalCredits}
            color="#3B82F6" // Blue
            label={commonTranslation.creditsUsed}
          />
        </Col>
        <Col span={12}>
          <DonutChart
            title={commonTranslation.students}
            value={creditUsage.student.usedCredits}
            total={creditUsage.student.totalCredits}
            color="#10B981" // Green
            label={commonTranslation.creditsUsed}
          />
        </Col>
      </Row>
      {/* </Flex> */}
      {/* Advisor Tips Section */}
      <Text
        size="large"
        weight="semibold"
        content={translation.advisorTips.title}
        style={{
          color: "#374151",
        }}
      />

      <Row gutter={[10, 10]}>
        {translation.advisorTips.tips.map((tip, index) => (
          <Col span={8} key={index}>
            <AdvisorTip content={tip} />
          </Col>
        ))}
      </Row>
    </Flex>
  ) : (
    <Text content={commonTranslation.noData} />
  );
};

export default OverviewTab;
